module.exports = __webpack_public_path__ + "img/stopwatch-white.9a56bb55.svg";